import { render, staticRenderFns } from "./landing-page-settings-widget.vue?vue&type=template&id=4ff9c0f6&"
import script from "./landing-page-settings-widget.vue?vue&type=script&lang=js&"
export * from "./landing-page-settings-widget.vue?vue&type=script&lang=js&"
import style0 from "./landing-page-settings-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports